import { SERVER_URL } from '@/config/serverUrl';
const BASE = SERVER_URL;

/** Clan emblems may be uploaded at runtime or bundled with the app. */
export function isImageAssetUrl(url: string | null | undefined): url is string {
  return Boolean(url && /^(https?:|\/uploads\/|\/assets\/)/.test(url));
}

/**
 * Resolve an `/uploads/...` URL the server hands out into something the
 * browser can fetch. When `VITE_SERVER_URL` is empty (production same-origin
 * via nginx) we return the path as-is; in dev we prepend the API origin so
 * <img> tags and Pixi.Assets can fetch cross-origin.
 */
export function resolveAssetUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Source-controlled art is bundled with the web/native client. In a
  // Capacitor build it must stay on capacitor://localhost instead of being
  // rewritten to the remote API origin.
  if (url.startsWith('/assets/')) return url;
  if (url.startsWith('/')) return `${BASE}${url}`;
  return url;
}
